import { MigrationInterface, QueryRunner } from 'typeorm'
import { Domain, getRepository } from '@things-factory/shell'
import { KpiPeriodType } from '../service/kpi/kpi'
import { KpiMetric, KpiMetricCollectType } from '../service/kpi-metric/kpi-metric'
import * as fs from 'fs'
import * as path from 'path'

interface KpiMetricSeedData {
  name: string
  description: string
  unit?: string | null
  source?: string | null
  field_name?: string | null
  active: boolean
  schedule_id?: string | null
  timezone: string
  data_set_id?: string | null
  period_type: string
  collect_type: string
  schedule?: string | null
  meta?: any
  created_at?: string
  updated_at?: string
}

export class SeedKpiMetrics1752190849680 implements MigrationInterface {
  name = 'SeedKpiMetrics1752190849680'

  public async up(queryRunner: QueryRunner): Promise<void> {
    try {
      const repository = getRepository(KpiMetric)
      const domainRepository = getRepository(Domain)

      // SYSTEM 도메인 확인
      const domain: Domain = await domainRepository.findOneBy({ name: 'SYSTEM' })
      if (!domain) {
        console.log('❌ SYSTEM domain not found')
        return
      }

      // JSON 파일 읽기
      const seedFilePath = path.join(__dirname, 'seed-data', 'kpi-metrics-seed.json')
      const seedData: KpiMetricSeedData[] = JSON.parse(fs.readFileSync(seedFilePath, 'utf8'))

      console.log(`📊 Processing ${seedData.length} KPI metrics from JSON seed`)

      for (const metricData of seedData) {
        try {
          const existingMetric = await repository.findOne({
            where: { name: metricData.name, domain: { id: domain.id } }
          })

          if (existingMetric) {
            console.log(`⚠️  KPI Metric already exists: ${metricData.name}`)
            continue
          }

          const metric = await repository.save({
            name: metricData.name,
            description: metricData.description,
            unit: metricData.unit,
            source: metricData.source,
            fieldName: metricData.field_name,
            active: metricData.active,
            scheduleId: metricData.schedule_id,
            timezone: metricData.timezone,
            dataSetId: metricData.data_set_id,
            periodType: KpiPeriodType[metricData.period_type as keyof typeof KpiPeriodType],
            collectType: KpiMetricCollectType[metricData.collect_type as keyof typeof KpiMetricCollectType],
            schedule: metricData.schedule,
            meta: (metricData as any).meta,
            domain
          })

          console.log(`✅ Created KPI Metric: ${metric.name}`)
        } catch (error) {
          console.error(`❌ Error creating KPI Metric "${metricData.name}":`, error)
        }
      }

      console.log(`🎉 Successfully processed KPI metrics from JSON seed`)
    } catch (error) {
      console.error('❌ Error seeding KPI metrics from JSON:', error)
      throw error
    }
  }

  public async down(queryRunner: QueryRunner): Promise<void> {
    try {
      const repository = getRepository(KpiMetric)
      const domainRepository = getRepository(Domain)

      const domain: Domain = await domainRepository.findOneBy({ name: 'SYSTEM' })
      if (!domain) {
        console.log('⚠️  SYSTEM domain not found. Nothing to delete.')
        return
      }

      // JSON 파일 읽기
      const seedFilePath = path.join(__dirname, 'seed-data', 'kpi-metrics-seed.json')
      const seedData: KpiMetricSeedData[] = JSON.parse(fs.readFileSync(seedFilePath, 'utf8'))

      console.log(`🗑️  Cleaning up ${seedData.length} KPI metrics`)

      for (const metricData of seedData.reverse()) {
        try {
          const metric = await repository.findOne({
            where: { name: metricData.name, domain: { id: domain.id } }
          })

          if (metric) {
            await repository.delete(metric.id)
            console.log(`✅ Deleted KPI Metric: ${metricData.name}`)
          }
        } catch (error) {
          console.error(`❌ Error deleting KPI Metric "${metricData.name}":`, error)
        }
      }

      console.log(`🎉 Successfully cleaned up KPI metrics`)
    } catch (error) {
      console.error('❌ Error cleaning up KPI metrics:', error)
      throw error
    }
  }
}
